export default "__VITE_ASSET__BLtUBRmd__"